import Button from '../common/Button';
import './WriteActionButtons.scss';

const WriteActionButtons = ({ onCancel, onPublish, isEdit }) => {
  return (
    <div className="WriteActionButtons">
      <Button write blue onClick={onPublish}>
        포스트 {isEdit ? '수정' : '등록'}
      </Button>
      <Button write onClick={onCancel}>
        취소
      </Button>
    </div>
  );
};

export default WriteActionButtons;
